import { render, staticRenderFns } from "./EmailColetivo.vue?vue&type=template&id=285fa715&scoped=true&"
import script from "./EmailColetivo.vue?vue&type=script&lang=js&"
export * from "./EmailColetivo.vue?vue&type=script&lang=js&"
import style0 from "./EmailColetivo.vue?vue&type=style&index=0&id=285fa715&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285fa715",
  null
  
)

export default component.exports